/**
 * Applied to a getter or setter property, will make it enumerable
 */
export function Enumerable() {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        descriptor.enumerable = true;
    };
}
